import { Seo } from "@/components/generals/seo"
import { Container } from "@/components/generals/container"
import { Section } from "@/components/generals/section"
import { LoginFormModern } from "@/components/login-form-modern"

export default function LoginPage() {
  return (
    <>
      <Seo
        title="Sign in"
        description="Sign in to Modulify AI Logo Maker to create and manage your logos."
        noIndex
      />

      <Section id="sign-in" size="lg">
        <Container width="content">
          <LoginFormModern />
        </Container>
      </Section>
    </>
  )
}
